import { FloatingFocusManager, FloatingPortal, useMergeRefs } from '@floating-ui/react'
import { forwardRef, HTMLProps } from 'react'

import { usePopoverContext } from './PopoverContext'

type PopoverContentProps = HTMLProps<HTMLDivElement> & {
  disableInitialFocus?: boolean
}

export const PopoverContent = forwardRef<HTMLDivElement, PopoverContentProps>(function PopoverContent(
  { disableInitialFocus, ...props },
  propRef
) {
  const { context: floatingContext, ...context } = usePopoverContext()
  const ref = useMergeRefs([context.refs.setFloating, propRef])

  return (
    <FloatingPortal>
      {context.open && (
        <FloatingFocusManager
          context={floatingContext}
          modal={context.modal}
          initialFocus={disableInitialFocus ? -1 : undefined}
        >
          <div
            ref={ref}
            style={{
              position: context.strategy,
              top: context.y ?? 0,
              left: context.x ?? 0,
              width: 'max-content',
              ...props.style,
            }}
            aria-labelledby={context.labelId}
            aria-describedby={context.descriptionId}
            {...context.getFloatingProps(props)}
          >
            {props.children}
          </div>
        </FloatingFocusManager>
      )}
    </FloatingPortal>
  )
})
